<template>
  <div class="horizontal layout center center-justified fit">
    <Loading />
  </div>
</template>

<script>
import { authentication, app } from '@microsoft/teams-js'
import * as Sentry from '@sentry/vue'
import utils from '@/util'

// components
import Loading from '@/components/Loading'

// services
import cookie from '@/services/cookie'
import { AHA_GUEST_USER } from '@/constant/storageKeys'

import { PRESENTER_REGISTER } from '@/constant/eventCategories'
import { ROUTE_NAMES } from '@/constant/routes'

export default {

  components: {
    Loading,
  },
  data() {
    return {
      isMSTeamsApp: false,
      zoomAppLoginRedirectUrl: null,
    }
  },
  async created() {
    const hasMSTeamsParamsInUrl = utils.getParamValue('ms_teams', window.location.href)
    this.isMSTeamsApp = hasMSTeamsParamsInUrl || (localStorage.getItem('ms_teams') == 'true')
    this.zoomAppLoginRedirectUrl = sessionStorage.getItem('zoomAppLoginRedirectUrl')
  },
  async mounted() {
    const {
      token,
      signup,
      admin,
      provider,
      isNew,
      popup,
    } = this.$route.query

    if (!token) {
      this.$router.push({
        name: ROUTE_NAMES.LOGIN,
      })
      return
    }

    this.$store.dispatch('setCurrentUserAction', {})

    if (isNew) {
      cookie.setValue('aha-new-user', true)
    }
    const isGuest = cookie.getValue(AHA_GUEST_USER)
    if (isGuest) {
      cookie.deleteValue(AHA_GUEST_USER)
    }

    utils.setCookieToken(token)
    this.$http.headers.common.Authorization = `Bearer ${token}`
    if (window.opener && popup) {
      try {
        if (window.opener.handleTokenApp) {
          window.opener.handleTokenApp(token)
        }
      } catch (error) {
        console.log('error', error)
      }
      window.close()
      return
    }
    try {
      if (this.isMSTeamsApp) {
        await app.initialize()
        authentication.notifySuccess(token)
      }
    } catch (error) {
      Sentry.captureException(error)
    }

    const audienceSSOLoginRedirect = cookie.getValue('audience-sso-login-redirect')

    if (audienceSSOLoginRedirect) {
      utils.handleAudienceTrackingAuthentication(isGuest, isNew, provider, audienceSSOLoginRedirect)
      cookie.deleteValue('audience-sso-login-redirect')
      window.location.href = audienceSSOLoginRedirect

      return
    }

    if (this.zoomAppLoginRedirectUrl) {
      window.location.href = this.zoomAppLoginRedirectUrl
      return
    }

    if (signup == 1) {
      this.$store.state.isComeFromSignupPage = true
      this.$router.push({ name: ROUTE_NAMES.HOME })
      return
    }

    if (admin) {
      this.$router.push({
        name: ROUTE_NAMES.HOME,
        query: { admin: true },
      })
      this.$store.state.isAdmin = true
      sessionStorage.setItem('isAdmin', 'true')
      return
    }

    if (provider) {
      utils.mixpanelTracking(
        PRESENTER_REGISTER, 'Sign up',
        'SSO',
        null,
        {
          provider,
        },
      )
      utils.trackGA4AndMixpanel('sign_up', {
        method: 'SSO',
      })
    }

    this.$router.push({
      name: ROUTE_NAMES.HOME,
    })
  },
}
</script>
